<template>
  <v-container class="my-5">
    <v-layout row wrap class="justify-center">
      <v-flex xs12>
        <v-card-title class="mb-4">
          <v-btn icon @click="$router.go(-1)" class="mr-3">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <span class="headline font-weight-bold">Gestión de Profesores</span>
          <v-spacer></v-spacer>
          <v-btn color="primary" rounded elevation="2" @click="openDialog()">
            <v-icon left>mdi-plus</v-icon>
            Agregar Profesor
          </v-btn>
        </v-card-title>

        <!-- Información General -->
        <v-card class="mb-4">
          <v-card-text class="pa-4">
            <v-row>
              <v-col cols="12" sm="6" md="3">
                <div class="text-center">
                  <div class="display-1 font-weight-bold primary--text">{{ teachers.length }}</div>
                  <div class="caption grey--text">Profesores Totales</div>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <div class="text-center">
                  <div class="display-1 font-weight-bold green--text">{{ activeTeachers }}</div>
                  <div class="caption grey--text">Activos</div>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <div class="text-center">
                  <div class="display-1 font-weight-bold orange--text">{{ totalClinicsAssigned }}</div>
                  <div class="caption grey--text">Clínicas Asignadas</div>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <div class="text-center">
                  <div class="display-1 font-weight-bold info--text">{{ totalStudentsAssigned }}</div>
                  <div class="caption grey--text">Alumnos en Clases</div>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- Tabla de Profesores -->
        <v-card class="elevation-1">
          <v-card-subtitle class="pa-4">
            <v-icon small class="mr-2">mdi-account-tie</v-icon>
            Listado de Profesores
          </v-card-subtitle>
          <v-data-table
            :headers="headers"
            :items="teachers"
            class="elevation-0"
            :no-data-text="$t('no_records_yet')">

            <template v-slot:item.name="{ item }">
              <div class="font-weight-bold">{{ item.name }}</div>
            </template>

            <template v-slot:item.availability="{ item }">
              <div class="caption">{{ item.availability }}</div>
            </template>

            <template v-slot:item.status="{ item }">
              <v-chip :color="item.status === 'activo' ? 'green' : 'grey'" small text-color="white">
                {{ item.status === 'activo' ? 'Activo' : 'Inactivo' }}
              </v-chip>
            </template>

            <template v-slot:item.clinics="{ item }">
              <v-chip small color="info" text-color="white">
                {{ getClinicsCount(item.id) }}
              </v-chip>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon small class="mr-2" v-bind="attrs" v-on="on" @click="editItem(item)">
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Editar</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon small v-bind="attrs" v-on="on" @click="confirmDelete(item)">
                    <v-icon small color="red">mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Eliminar</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- Diálogo para agregar/editar profesor -->
    <TeacherDialog
      :dialog.sync="dialog"
      :teacher="editedTeacher"
      @save="saveTeacher"
    />

    <!-- Diálogo de confirmación de eliminar -->
    <v-dialog v-model="deleteDialog" max-width="400px">
      <v-card>
        <v-card-title class="headline">Eliminar Profesor</v-card-title>
        <v-card-text>
          ¿Estás seguro de que deseas eliminar a <strong>{{ deleteItem?.name }}</strong>?
          <p class="caption grey--text mt-2">
            Esta acción no se puede deshacer.
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="deleteDialog = false">Cancelar</v-btn>
          <v-btn color="red" text @click="deleteTeacher">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="3000" top>
      {{ snackbarMessage }}
    </v-snackbar>
  </v-container>
</template>

<script>
import TeacherDialog from './components/TeacherDialog.vue'

export default {
  name: 'AcademyTeachers',
  components: {
    TeacherDialog
  },
  data () {
    return {
      dialog: false,
      deleteDialog: false,
      deleteItem: null,
      snackbar: false,
      snackbarMessage: '',
      snackbarColor: 'success',
      editedTeacher: null,
      headers: [
        { text: 'Nombre', value: 'name', width: '25%' },
        { text: 'Disponibilidad', value: 'availability', width: '30%' },
        { text: 'Estado', value: 'status', width: '12%' },
        { text: 'Clínicas', value: 'clinics', width: '12%', align: 'center' },
        { text: 'Acciones', value: 'actions', width: '15%', sortable: false, align: 'center' }
      ],
      // MOCK DATA
      teachers: [
        {
          id: 1,
          name: 'Carlos López García',
          availability: 'Lunes, Miércoles, Viernes (9:00 AM - 2:00 PM)',
          status: 'activo',
          email: 'carlos.lopez@club.com',
          phone: '+34 666 123 456',
          specialties: ['Swing', 'Full Swing'],
          certification: 'PGA Profesional'
        },
        {
          id: 2,
          name: 'María Rodríguez',
          availability: 'Martes, Jueves, Sábado (10:00 AM - 3:00 PM)',
          status: 'activo',
          email: 'maria.rodriguez@club.com',
          phone: '+34 666 789 012',
          specialties: ['Putting', 'Short Game'],
          certification: 'Golf Coach Certificada'
        },
        {
          id: 3,
          name: 'Fernando Ruiz',
          availability: 'Lunes, Miércoles, Sábado (2:00 PM - 6:00 PM)',
          status: 'activo',
          email: 'fernando.ruiz@club.com',
          phone: '+34 666 345 678',
          specialties: ['Pitch', 'Chip'],
          certification: 'Instructor Senior'
        },
        {
          id: 4,
          name: 'Ana Martínez',
          availability: 'Martes, Jueves (11:00 AM - 1:00 PM)',
          status: 'activo',
          email: 'ana.martinez@club.com',
          phone: '+34 666 987 654',
          specialties: ['Técnica Básica'],
          certification: 'Instructor Golf'
        }
      ],
      clinics: [
        { id: 1, teacher_id: 1, date: '2025-08-08', time: '09:00' },
        { id: 2, teacher_id: 2, date: '2025-08-09', time: '10:00' },
        { id: 3, teacher_id: 3, date: '2025-08-10', time: '14:00' },
        { id: 4, teacher_id: 1, date: '2025-08-12', time: '09:00' },
        { id: 5, teacher_id: 2, date: '2025-08-15', time: '10:00' }
      ]
    }
  },
  computed: {
    activeTeachers () {
      return this.teachers.filter(t => t.status === 'activo').length
    },
    totalClinicsAssigned () {
      return this.clinics.length
    },
    totalStudentsAssigned () {
      // Mock: contar alumnos totales en clínicas (cada clínica tiene ~3-5 alumnos)
      return this.clinics.length * 4
    }
  },
  methods: {
    getClinicsCount (teacherId) {
      return this.clinics.filter(c => c.teacher_id === teacherId).length
    },
    openDialog () {
      this.editedTeacher = null
      this.dialog = true
    },
    editItem (teacher) {
      this.editedTeacher = { ...teacher }
      this.dialog = true
    },
    confirmDelete (teacher) {
      this.deleteItem = teacher
      this.deleteDialog = true
    },
    deleteTeacher () {
      const index = this.teachers.findIndex(t => t.id === this.deleteItem.id)
      if (index > -1) {
        this.teachers.splice(index, 1)
        // También eliminar clínicas asociadas
        this.clinics = this.clinics.filter(c => c.teacher_id !== this.deleteItem.id)
      }
      this.snackbarMessage = `Profesor ${this.deleteItem.name} eliminado correctamente`
      this.snackbarColor = 'success'
      this.snackbar = true
      this.deleteDialog = false
    },
    saveTeacher (teacher) {
      if (this.editedTeacher && this.editedTeacher.id) {
        // Editar existente
        const index = this.teachers.findIndex(t => t.id === this.editedTeacher.id)
        if (index > -1) {
          this.teachers[index] = { ...this.editedTeacher, ...teacher }
        }
        this.snackbarMessage = 'Profesor actualizado correctamente'
      } else {
        // Crear nuevo
        const newTeacher = {
          id: Math.max(...this.teachers.map(t => t.id), 0) + 1,
          ...teacher
        }
        this.teachers.push(newTeacher)
        this.snackbarMessage = 'Profesor agregado correctamente'
      }
      this.snackbarColor = 'success'
      this.snackbar = true
      this.dialog = false
    }
  }
}
</script>

<style scoped>
</style>
